import { isServerside } from '../core/utils/isServerside';

export const getSearchAPIEndpoint = (): string | undefined => {
  // An option for the hawk-client to override the endpoint to avoid ad blockers
  if (!isServerside() && window.hawk_search_api_endpoint) {
    return window.hawk_search_api_endpoint;
  }

  return process.env.SEARCH_API_ENDPOINT;
};
